import { getCellDefaults, getRundownDefaults } from '~shared/types'
import { parseSnapshot } from '~shared/utils'

/**
 * Rundown specific wrapper for parseSnapshot
 */
export function parseRundownSnapshot(snapshot) {
  const defaults = getRundownDefaults()
  const dateKeys = ['startTime', 'endTime', 'archivedAt', 'deletedAt']
  return parseSnapshot(snapshot, { defaults, dateKeys })
}

/**
 * Cell specific wrapper for parseSnapshot
 */
export function parseCellSnapshot(snapshot) {
  const defaults = getCellDefaults()
  const dateKeys = []
  return parseSnapshot(snapshot, { defaults, dateKeys })
}
